import React, { Component } from 'react';

class getRubros extends Component {
  mostrarRubros = () => {
    const rubros = this.props.rubros;
    if(rubros.length === 0) return null;
    return (
      <React.Fragment>
        {rubros.map(rubro => (
          <button key={rubro.id_rubro} className="boton_rubros"  onClick={ () => this.props.datosBusquedaSubRubro(rubro.id_rubro)}>{rubro.rubro}</button>
        )) }

      </React.Fragment>
    )
    //console.log("id_subrubro");
  }

  render() {


    let data;
        if (this.props.ok_rubro===false) {
          data =<div className="div_lbl_loading"><img alt="Cargando Imagen . . ."  className="lbl_loading" src={ require('../images/loading.gif') } /></div>
          //console.log(this.props.ok_rubro);
        } else {
          data = <div>
            {
            this.mostrarRubros()
            }
          </div>
        }
          return(
          <div>
                {data}
           </div>
          )


  }

  componentDidMount() {
    this.props.consultarRubroAPI();
  }
  componentDidUpdate (){
    const rubros = this.props.rubros;
    const id_rubro = this.props.id_rubro;
    let id_new_rubro='';
    if(rubros.length === 0) return null;
    if(id_rubro==='0'&&rubros.length !== 0){
      for (var i = 0; i < rubros.length; i++) {
        id_new_rubro = rubros[i].id_rubro;
        break;
      }
      this.props.datosBusquedaSubRubro(id_new_rubro)
    }
  }


}

export default getRubros;
